import {css} from 'lit';
export const styles = css`:host([color='10']) ef-icon {
  color: var(--tag-color-10);
}

:host([color='20']) ef-icon {
  color: var(--tag-color-20);
}

:host([color='30']) ef-icon {
  color: var(--tag-color-30);
}

:host([color='40']) ef-icon {
  color: var(--tag-color-40);
}

:host([color='50']) ef-icon {
  color: var(--tag-color-50);
}

:host([color='60']) ef-icon {
  color: var(--tag-color-60);
}

:host([color='70']) ef-icon {
  color: var(--tag-color-70);
}

:host([color='80']) ef-icon {
  color: var(--tag-color-80);
}

:host([color='90']) ef-icon {
  color: var(--tag-color-90);
}

:host([color='100']) ef-icon {
  color: var(--tag-color-100);
}

:host([color='110']) ef-icon {
  color: var(--tag-color-110);
}

:host([color='120']) ef-icon {
  color: var(--tag-color-120);
}

:host([color='130']) ef-icon {
  color: var(--tag-color-130);
}

:host([color='140']) ef-icon {
  color: var(--tag-color-140);
}

:host([color='150']) ef-icon {
  color: var(--tag-color-150);
}

:host([color='160']) ef-icon {
  color: var(--tag-color-160);
}

:host([color='170']) ef-icon {
  color: var(--tag-color-170);
}

:host([color='180']) ef-icon {
  color: var(--tag-color-180);
}

:host([color='190']) ef-icon {
  color: var(--tag-color-190);
}

:host([color='200']) ef-icon {
  color: var(--tag-color-200);
}

:host([color='210']) ef-icon {
  color: var(--tag-color-210);
}

:host([color='220']) ef-icon {
  color: var(--tag-color-220);
}

:host([color='230']) ef-icon {
  color: var(--tag-color-230);
}

:host([color='240']) ef-icon {
  color: var(--tag-color-240);
}

:host([color='250']) ef-icon {
  color: var(--tag-color-250);
}

:host {
  display: inline-block;
}

:host > a {
  display: flex;
  align-items: center;
  color: var(--dark-text);
  padding: 4px;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
}

ef-icon {
  margin-right: 4px;
  font-size: 20px;
  opacity: 0.7;
  transition: opacity ease-in-out 0.2s;
}

@media (hover: hover) {
  :host(:hover) ef-icon {
    opacity: 1;
  }
}

:host(:active) ef-icon {
  opacity: 0.5;
}
`;
export default styles;
